import {
    createBrowserRouter,
  } from "react-router-dom";
import { Suspense } from 'react';
import HomeScreen from "./screen/HomeScreen/HomeScreen";
import RestauScreen from "./screen/RestauScreen/RestauScreen";

import React from "react";

import ResetPassword from "./screen/ResetPassword/resetPassword";
import PublishedPage from "./screen/Restaurateur/published/published";

import RedirectionScreen from "./screen/RedirectionScreen/RedirectionScreen";

import ProtectedRoadResto from "./screen/ProtectedRoad/ProtectedRoadResto";
import ProtectedRoadInscription from "./screen/ProtectedRoad/ProtectedRoadInscription";

import ProtectedRoad from "./screen/ProtectedRoad/ProtectedRoad";
import InscriptionScreen from "./screen/inscriptionScreen/inscriptionScreen";

import PageCancel from "./screen/pagePayment/pageCancel";
import PageSuccess from "./screen/pagePayment/pageSuccess";
import PageRefuse from "./screen/pagePayment/pageRefuse";


const MapOpenComponent = React.lazy(() => import("./components/map/map"));

const APropos = React.lazy(() => import("./screen/InformationScreen/APropos"));
const ContactezNous = React.lazy(() => import("./screen/InformationScreen/ContactezNous"));
const Fonctionnement = React.lazy(() => import("./screen/InformationScreen/Fonctionnement"));
const ConditionsGeneralesUtilisation = React.lazy(() => import("./screen/InformationScreen/ConditionsGeneralesUtilisation"));
const MentionsLegales = React.lazy(() => import("./screen/InformationScreen/MentionsLegales"));
const PolitiqueCookies = React.lazy(() => import("./screen/InformationScreen/PolitiqueCookies"));
const PolitiqueConfidentialite = React.lazy(() => import("./screen/InformationScreen/PolitiqueConfidentialite"));
const CharteQuelResto = React.lazy(() => import("./screen/InformationScreen/CharteQuelResto")); 

const LegalObligation = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/legalObligation"));
const MentionsLegalesResto = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/mentionsLegalesResto"));
const PolitiqueConfidentialiteResto = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/politiqueConfidentialiteResto"));
const PolitiqueCookiesResto = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/politiqueCookiesResto"));
const ConditionsGeneralesUtilisationResto = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/conditionsGeneralesUtilisationResto"));
const ConditionsGeneralesVenteResto = React.lazy(() => import("./screen/HomeScreen/Footer/footerClient/conditionsGeneralesVenteResto"));

const ReservationPage = React.lazy(() => import("./screen/Restaurateur/reservation/homeReservation"));
const ModifyMenu = React.lazy(() => import("./screen/Restaurateur/menu/modifyMenu"));
const ModifyInfo = React.lazy(() => import("./screen/Restaurateur/information/modifyInformation"));
const ModifyDescription = React.lazy(() => import("./screen/Restaurateur/description/modifyDescription"));
const Statistics = React.lazy(() => import("./screen/Restaurateur/statistics/statistics"));

const AdminScreen  = React.lazy(() => import("./screen/AdminScreen/AdminScreen"));
const AdminMarketScreen = React.lazy(() => import("./screen/AdminMarketScreen/adminMarketScreen"));
const PageElem = React.lazy(() => import("./screen/AdminScreen/preFilled/pageElemAccount/pageElem"));

const ProfilForVisitor = React.lazy(() => import("./screen/profilForVisitor/profilForVisitor"));
const ProfilScreen = React.lazy(() => import("./screen/profilScreen/profilScreen"));

const ContactInscription = React.lazy(() => import("./screen/contactInscription/contactInscription"));

const RestaurateurLogin = React.lazy(() => import("./screen/Restaurateur/restaurateurLogin/restaurateurLogin"));

const router = createBrowserRouter([
    {
      path: "/:city?",
        element: <HomeScreen/>
    },
    {
      path: "/map",
        element: <Suspense fallback={<div>Chargement…</div>}><MapOpenComponent /></Suspense>
    },
    {
      path:"/restaurant/:city/:slugWithId",
        element: <RestauScreen />
    },
    {
    path: "/ContactezNous",
    element: <Suspense fallback={<div>Chargement…</div>}><ContactezNous /></Suspense>
  },
  {
    path: "/APropos",
    element: <Suspense fallback={<div>Chargement…</div>}><APropos /></Suspense>
  },
  {
    path: "/ConditionsGeneralesUtilisation",
    element: <Suspense fallback={<div>Chargement…</div>}><ConditionsGeneralesUtilisation /></Suspense>
  },
  {
    path: "/Fonctionnement",
    element: <Suspense fallback={<div>Chargement…</div>}><Fonctionnement /></Suspense>
  },
  {
    path: "/MentionsLegales",
    element: <Suspense fallback={<div>Chargement…</div>}><MentionsLegales /></Suspense>
  },
  {
    path: "/PolitiqueCookies",
    element: <Suspense fallback={<div>Chargement…</div>}><PolitiqueCookies /></Suspense>
  },
  {
    path: "/CharteQuelResto",
    element: <Suspense fallback={<div>Chargement…</div>}><CharteQuelResto /></Suspense>
  },
  {
    path: "/PolitiqueConfidentialite",
    element: <Suspense fallback={<div>Chargement…</div>}><PolitiqueConfidentialite /></Suspense>
  },
  {
    path: "/legalObligation",
    element: <Suspense fallback={<div>Chargement…</div>}><LegalObligation /></Suspense>
  },
  {
    path: "/mentionsLegalesResto",
    element: <Suspense fallback={<div>Chargement…</div>}><MentionsLegalesResto /></Suspense>
  },
  {
    path: "/politiqueConfidentialiteResto",
    element: <Suspense fallback={<div>Chargement…</div>}><PolitiqueConfidentialiteResto /></Suspense>
  },
  {
    path: "/politiqueCookiesResto",
    element: <Suspense fallback={<div>Chargement…</div>}><PolitiqueCookiesResto /></Suspense>
  },
  {
    path: "/conditionsGeneralesUtilisationResto",
    element: <Suspense fallback={<div>Chargement…</div>}><ConditionsGeneralesUtilisationResto /></Suspense>
  },
  {
    path: "/conditionsGeneralesVenteResto",
    element: <Suspense fallback={<div>Chargement…</div>}><ConditionsGeneralesVenteResto /></Suspense>
  },
    {
      path:"/restaurateurLogin",
      element: 
        <ProtectedRoadResto>
          <Suspense fallback={<div>Chargement…</div>}><RestaurateurLogin /></Suspense>
        </ProtectedRoadResto>
    },
    {
      path:"/modifyMenu/:date_post?",
      element: 
        <ProtectedRoadResto>
          <Suspense fallback={<div>Chargement…</div>}>
            <ModifyMenu />
          </Suspense>
        </ProtectedRoadResto>
    },
    {
      path:"/reservationPage",
      element: 
        <ProtectedRoadResto>
          <Suspense fallback={<div>Chargement…</div>}>
            <ReservationPage />
          </Suspense>
        </ProtectedRoadResto>
    },
    {
      path:"/modifyInfo/:encodedData",
      element: 
        <ProtectedRoadResto>
          <Suspense fallback={<div>Chargement…</div>}>
            <ModifyInfo />
          </Suspense>
        </ProtectedRoadResto>
    },
    {
      path:"/modifyDescription",
      element: <ProtectedRoadResto>
        <Suspense fallback={<div>Chargement…</div>}>
        <ModifyDescription />
        </Suspense>
      </ProtectedRoadResto>
    },
    {
      path:"/statistiques",
      element: 
        <ProtectedRoadResto>
          <Suspense fallback={<div>Chargement…</div>}>
            <Statistics />
          </Suspense>
        </ProtectedRoadResto>
    },
    {
      path:"/restaurateur/publication",
      element:
        <ProtectedRoadResto>
          <PublishedPage />
        </ProtectedRoadResto> 
    },
    {
      path:"/reset-password/:token",
      element: <ResetPassword />
    },
    {
      path:"/profilForVisitor/:idUser",
      element: <Suspense fallback={<div>Chargement…</div>}><ProfilForVisitor /></Suspense>
    },
    {
      path:"/profilScreen",
      element: <Suspense fallback={<div>Chargement…</div>}><ProfilScreen/></Suspense>
    },
    {
      path:"/contact_inscription",
      element: <Suspense fallback={<div>Chargement…</div>}><ContactInscription /></Suspense>
    },
    {
      path:"/payment/cancel",
      element: <PageCancel />
    },
    {
      path:"/payment/refuse",
      element: <PageRefuse />
    },
    {
      path:"/payment/success",
      element: <PageSuccess />
    },
    {
      path:"/register/restaurateur",
      element:
        <ProtectedRoadInscription>
          <InscriptionScreen />
        </ProtectedRoadInscription> 
    },
    {
      path:"/admin/lQjbFiF57Gfjaojha5ikcjh9zih5hekE/:page?/:restoStat?",
      element: <ProtectedRoad>
        <Suspense fallback={<div>Chargement…</div>}>
          <AdminScreen />
          </Suspense>
      </ProtectedRoad>
    },
    {
      path:"/admin/lQjbFiF57Gfjaojha5ikcjh9zih5hekE/pageElem/:id/:name",
      element: <ProtectedRoad>
        <Suspense fallback={<div>Chargement…</div>}>
          <PageElem />
          </Suspense>
      </ProtectedRoad>
    },
    {
      path:"/admin/bhZTYoSaZEhhVeikdhELREnOviiohVgz",
      element: <ProtectedRoad>
        <Suspense fallback={<div>Chargement…</div>}>
          <AdminMarketScreen />
          </Suspense>
      </ProtectedRoad>
    },
    {
      path:"*",
      element: <RedirectionScreen/>
    },

    
     ])

export default router